import type { CSSProperties, FC } from 'react';
import { Flex as AntFlex, type FlexProps as AntFlexProps } from 'antd';
import styled, { css } from 'styled-components';

export interface FlexProps extends AntFlexProps {
  $minWidth?: CSSProperties['minWidth'];
  $maxWidth?: CSSProperties['maxWidth'];
}

const StyledFlex = styled(AntFlex)<FlexProps>`
  ${({ $minWidth }) =>
    $minWidth &&
    css`
      min-width: ${typeof $minWidth === 'number' ? `${$minWidth}px` : $minWidth};
    `}

  ${({ $maxWidth }) =>
    $maxWidth &&
    css`
      max-width: ${typeof $maxWidth === 'number' ? `${$maxWidth}px` : $maxWidth};
    `}
`;

export const Flex: FC<FlexProps> = ({ children, ...rest }) => {
  return <StyledFlex {...rest}>{children}</StyledFlex>;
};
